import React from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { ExportJobStatusView } from "./ExportJobStatusView";

interface ExportJobStatusDialogProps {
  jobId: string | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

/**
 * Standalone status dialog — used by the audit log to inspect a job. Opening it
 * calls `GET /jobs/:jobId` (via {@link ExportJobStatusView}), which mints a fresh
 * `downloadUrl` (list rows carry `downloadUrl: null`).
 */
export const ExportJobStatusDialog: React.FC<ExportJobStatusDialogProps> = ({
  jobId,
  open,
  onOpenChange,
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-h-[90vh] max-w-xl overflow-y-auto">
      {jobId ? (
        <ExportJobStatusView
          key={jobId}
          jobId={jobId}
          onClose={() => onOpenChange(false)}
        />
      ) : null}
    </DialogContent>
  </Dialog>
);
